import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ChevronDown, Menu, X } from "lucide-react";
import { BUSINESS } from "@/data/content";

const serviceLinks = [
  { to: "/services", label: "All Services" },
  { to: "/services/ceramic-coating", label: "Ceramic Coating" },
  { to: "/services/paint-protection-film", label: "PPF & Vinyl Wraps" },
  { to: "/pricing", label: "Detailing Packages" },
];

const navLinks = [
  { to: "/gallery", label: "Gallery" },
  { to: "/about", label: "About" },
  { to: "/journal", label: "Journal" },
  { to: "/contact", label: "Contact" },
];

const Logo = () => (
  <Link to="/" data-testid="nav-logo" className="flex items-center gap-3" aria-label="Luxpress Detailing — home">
    <img src="/assets/logo.png" alt="Luxpress Detailing" className="h-7 w-auto sm:h-8" />
  </Link>
);

const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-teal-line bg-black/90 backdrop-blur-md">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8" aria-label="Primary">
        <Logo />
        <div className="hidden items-center gap-8 lg:flex">
          <div className="group relative">
            <button
              data-testid="nav-services-dropdown"
              className="flex items-center gap-1 font-mono text-xs uppercase tracking-[0.2em] text-chrome transition-colors duration-300 hover:text-mint"
              aria-haspopup="true"
            >
              Services <ChevronDown className="h-3.5 w-3.5 transition-transform duration-300 group-hover:rotate-180" aria-hidden="true" />
            </button>
            <div className="invisible absolute left-0 top-full w-64 border border-teal-line bg-panel pt-2 opacity-0 transition-all duration-300 group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100">
              {serviceLinks.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  data-testid={`nav-dropdown-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="block px-5 py-3 font-mono text-xs uppercase tracking-[0.18em] text-chrome transition-colors duration-200 hover:bg-teal-deep hover:text-mint"
                >
                  {l.label}
                </NavLink>
              ))}
            </div>
          </div>
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-mono text-xs uppercase tracking-[0.2em] transition-colors duration-300 ${isActive ? "text-mint" : "text-chrome hover:text-mint"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" data-testid="nav-quote-cta" className="btn-primary !px-5 !py-2.5 !text-xs">
            Get a Quote
          </Link>
        </div>
        <button
          data-testid="nav-mobile-toggle"
          className="text-white lg:hidden"
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          aria-label={open ? "Close menu" : "Open menu"}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>
      {open && (
        <div className="border-t border-teal-line bg-black px-5 pb-24 pt-4 lg:hidden" data-testid="nav-mobile-menu">
          <p className="spec-label mb-2">Services</p>
          {serviceLinks.map((l) => (
            <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)} className="block py-3 font-display text-lg font-bold uppercase text-white" data-testid={`nav-mobile-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              {l.label}
            </NavLink>
          ))}
          <div className="hairline my-4" />
          {navLinks.map((l) => (
            <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)} className="block py-3 font-display text-lg font-bold uppercase text-white" data-testid={`nav-mobile-${l.label.toLowerCase()}`}>
              {l.label}
            </NavLink>
          ))}
          <a href={BUSINESS.phoneHref} data-testid="nav-mobile-call" className="btn-ghost mt-6 w-full">
            Call {BUSINESS.phoneDisplay}
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
